import { ActionReducerMap, MetaReducer } from '@ngrx/store';

import * as fromAdmin from './admin/admin.reducer';
import * as fromAppConfig from './app-config/app-config.reducer';
import * as fromAuth from './auth/auth.reducer';
import * as fromMapControl from './map-control/map-control.reducer';
import * as fromNotification from './notification/notification.reducer';
import * as fromParcel from './parcel/parcel.reducer';
import * as fromSite from './site/site.reducer';
import { storageMetaReducer } from './storage.metareducer';

export interface AppState {
  [fromParcel.parcelFeatureKey]: fromParcel.ParcelState;
  [fromMapControl.mapControlFeatureKey]: fromMapControl.MapControlState;
  [fromAuth.authFeatureKey]: fromAuth.AuthState;
  [fromAdmin.adminFeatureKey]: fromAdmin.AdminState;
  [fromSite.siteFeatureKey]: fromSite.SiteState;
  [fromNotification.notificationFeatureKey]: fromNotification.NotificationState;
  [fromAppConfig.appConfigFeatureKey]: fromAppConfig.AppConfigState;
}

export const reducers: ActionReducerMap<AppState> = {
  parcel: fromParcel.reducer,
  mapControl: fromMapControl.reducer,
  auth: fromAuth.reducer,
  admin: fromAdmin.reducer,
  site: fromSite.reducer,
  notification: fromNotification.reducer,
  appConfig: fromAppConfig.reducer,
};

export const metaReducers: MetaReducer<AppState>[] = [storageMetaReducer];
